<template>
    <div class="manual-orders">
      <h3>Manual Orders</h3>

      <div class="left-float col-2 form">
        <form @submit.prevent="formSubmit(formData)">

          <div class="form-group">
            <select id="range-options" v-model="formData.orderSide" required>
              <option selected>Selecione</option>
              <option value="buy">Compra</option>
              <option value="sell">Venda</option>
            </select>
          </div>

          <div class="form-group">
            <label>Price:</label>
            <input type="number" id="price" v-model="formData.price" required step="0.01" min="0"/>
          </div>

          <div class="form-group">
            <label>Quantity:</label>
            <input type="number" id="qty" v-model="formData.qty" min="0" required step="0.000001" placeholder="0.000001"/>
          </div>

          <div class="form-group">
            <label>Exchange:</label>
            <select id="exchange" v-model="formData.exchange" required>
              <option selected>Selecione</option>
              <option value="hyperliquid">HyperLiquid</option>
              <option value="mexc">Mexc</option>
              <option value="sideswap">SideSwap</option>
            </select>
          </div>

          <div class="form-group">
            <label>excgAccount:</label>
            <input type="text" id="excgAccount" v-model="formData.excgAccount" required/>
          </div>

          <div class="form-group">
            <label>ExcgID:</label>
            <input type="text" id="excgID" v-model="formData.excgID" required/>
          </div>

          <div v-if="formData.orderSide === 'sell' && formData.price && formData.qty" class="form-group">
            <label>Selecione as Ordens de Compra para Cálculo do Lucro:</label>
            <select v-model="selectedCompras" required multiple>
              <option v-for="compra in selectedCompras" :key="compra.orderId" :value="compra">
                {{ compra }}
              </option>
            </select>
          </div>

          <p v-if="!validacaoStatus.quantidadeSuficiente">A quantidade total das ordens selecionadas é insuficiente para cobrir a quantidade de venda. Selecione mais ordens. {{ validacaoStatus.totalQty }} / {{ validacaoStatus.quantidadeVenda }}</p>
          <button v-if="validacaoStatus.quantidadeSuficiente" type="submit">Enviar</button>
        
        </form>
      </div>

      <div class="right-float col-2 manual-list">
        <div v-for="(mOrder, index) in manualOrders" class="order-container full-width buy-order" :key="index">
            <div class="left-float">
                <p class="orderPrice">{{ mOrder.current.avgPrice }}</p>
                <p class="orderPrice">{{ mOrder.current.qty }}</p>
                <p>{{ mOrder.unitID }}</p>
                <p>{{ mOrder.excgID }}</p>
            </div>
            <div class="right-float">
              <span class="span-button" @click="openEditModal(mOrder)">Edit</span>
              <input v-if="formData.orderSide === 'sell' && formData.price && formData.qty" type="checkbox" :id="'selectOrder_' + mOrder.unitID" :value="mOrder" v-model="selectedCompras"/>
            </div>
        </div>
      </div>



    </div>
</template>

<script>
import { mapState } from 'vuex';
import { inject } from 'vue';
import editManualOrderForm from '@/forms/editManualOrderForm.vue';

export default {
  name: 'manualOrdersForm',
  data() {
    return {
      formData: {},
      selectedCompras: [],
      validacaoStatus: {
        quantidadeSuficiente: true
      }
    };
  },
  setup() {
    const openModal = inject('openModal');

    function openEditModal(orderData) {
      openModal(editManualOrderForm, orderData);
    }

    return { openEditModal };
  },
  computed: {
    ...mapState({
        manualUnits: state => {
          return Object.values(state.ledger || {}).filter(item => item.bucket === 'manual');
        },
    }),
    manualOrders() {
      const units = this.manualUnits;
      if (this.formData.orderSide === 'sell' && this.formData.price > 0 && this.formData.qty > 0) {
        return Object.values(units)
          .filter(unit => unit.current.qty > 0 && unit.current.avgPrice < this.formData.price)
          .sort((a, b) => a.current.avgPrice - b.current.avgPrice);
      } else{
        return Object.values(units).sort((a, b) => a.current.avgPrice - b.current.avgPrice);
      }
    }
  },
  watch: {
    'selectedCompras': function () {
      this.validarOrdensSelecionadas();
    }
  },
  methods: {
    formSubmit(formData) {
        const req = {
          type: 'sendManualOrder',
          orderDetails: formData,
        }

        if (this.formData.orderSide === 'sell'){
          req.buys = this.selectedCompras
          req.unitsToUse = this.selectedCompras.map(order => order.unitID)
        }
          
        console.log(req)
        this.$store.state.socket.send(JSON.stringify(req));
        this.formData = {}
        this.selectedCompras = []
    },
    validarOrdensSelecionadas() {
      let totalQty = 0;
      const quantidadeVenda = this.formData.qty;
      
      totalQty = this.selectedCompras.reduce((sum, order) => sum + order.current.qty, 0); // Soma as quantidades disponíveis das ordens selecionadas
      this.validacaoStatus.totalQty = totalQty;
      this.validacaoStatus.quantidadeVenda = quantidadeVenda;
      this.validacaoStatus.quantidadeSuficiente = totalQty >= quantidadeVenda; // Verifica se a quantidade total é suficiente
    }
  },
}
</script>

<style scoped>
.manual-orders {
  float: left;
  width: 900px;
}

.manual-orders .form {
  width: 400px;
}
.manual-list {
  height: 400px;
  overflow-y: scroll;
}
</style>
